export const messagesImgsOpenTag = '{{';
export const messagesImgsCloseTag = '}}';
// This match a string that contains {{something}} inside.
export const messagesImgsRegex = /({{([^}}]+)}})/i;

export const getTextFromChatMessage = (text: string) => {
  const returnValue = text?.replace(messagesImgsRegex, '');
  return returnValue;
};

export const getImageFromChatMessage = (text: string) => {
  const returnValue = text?.match(messagesImgsRegex);
  return returnValue?.[2];
};

export enum ReceiverType {
  User = 'User',
  Organization = 'Organization',
}
